import { faArrowRight } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as React from "react"
import { useEffect, useState } from "react"
import { Link, useNavigate } from "react-router-dom"

import classNames from "classnames"
import api, { ApiFieldError } from "../../../services/api"
import Input from "../../components/input"
import { useAuth } from "../../hooks/auth"
import useFlash from "../../hooks/use_flash"

export default function LoginPage() {
  const { userId } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (userId) {
      console.log("userId", userId)
      navigate("/app")
    }
  }, [userId, navigate])

  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [emailError, setEmailError] = useState("")
  const [passwordError, setPasswordError] = useState("")
  const [disabled, setDisabled] = useState(false)
  const { retry } = useAuth()
  const { flash } = useFlash()

  const formSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    setDisabled(true)

    try {
      setEmailError("")
      setPasswordError("")
      await api().post("/api/login", {
        email_address: email,
        password,
      })
    } catch (error: any) {
      if (error.response?.data?.errors) {
        error.response.data.errors.forEach((error: ApiFieldError) => {
          if (error.field == "email_address") {
            setEmailError(error.message)
          } else if (error.field == "password") {
            console.log("set password error", error.message)
            setPasswordError(error.message)
          }
        })
        setDisabled(false)
      }
    }
    await retry()
  }
  return (
    <>
      <div className="flex min-h-full flex-col justify-start py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-gray-900 dark:text-gray-200">
            Log in
          </h2>
          <div className="mt-2 text-sm text-center">
            <Link to="/app/register" className="font-medium text-indigo-600 hover:text-indigo-500">
              Sign up instead
              <FontAwesomeIcon icon={faArrowRight} className="ml-1 text-xs" />
            </Link>
          </div>
        </div>

        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-white dark:bg-gray-900 px-4 py-8 shadow sm:rounded-lg sm:px-10">
            <form className="space-y-6" onSubmit={formSubmit} method="POST">
              <Input
                label="Email address"
                name="email"
                type="text"
                error={emailError}
                onChange={(newValue) => setEmail(newValue)}
                disabled={disabled}
                value={email}
              />

              <Input
                label="Password"
                name="password"
                type="password"
                error={passwordError}
                onChange={(newValue) => setPassword(newValue)}
                disabled={disabled}
                value={password}
              />

              <div className="flex items-center justify-between">
                <div className="text-sm">
                  <Link
                    to="/app/forgot-password"
                    className="font-medium text-indigo-600 hover:text-indigo-500"
                  >
                    Forgot password
                  </Link>
                </div>
              </div>

              <div>
                <button
                  type="submit"
                  data-testid="login-button"
                  className={classNames(
                    "flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500 disabled:ring-gray-500"
                  )}
                  disabled={disabled}
                >
                  Log in
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  )
}
